// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"8dc1f376","121":"2d484789","369":"69b9bf5c","384":"1da7f210","481":"340dacea","974":"172e19af"}[chunkId] + ".chunk.js";
};